// extracted by mini-css-extract-plugin
export default {"video":"hc--video--video","video__image":"hc--video--video__image","video__play":"hc--video--video__play","modal":"hc--video--modal"};